import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "gridPerson" }
const _hoisted_2 = { style: {"grid-column":"left","justify-self":"end"} }
const _hoisted_3 = { style: {"grid-column":"right"} }
const _hoisted_4 = { style: {"grid-column":"left","justify-self":"end"} }
const _hoisted_5 = { style: {"grid-column":"right"} }
const _hoisted_6 = { style: {"grid-column":"left","justify-self":"end"} }
const _hoisted_7 = { style: {"grid-column":"right"} }
const _hoisted_8 = { style: {"grid-column":"left","justify-self":"end"} }
const _hoisted_9 = { style: {"grid-column":"right"} }
const _hoisted_10 = { style: {"grid-column":"left","justify-self":"end"} }
const _hoisted_11 = { style: {"grid-column":"right"} }
const _hoisted_12 = {
  key: 1,
  class: "font-m"
}
const _hoisted_13 = { style: {"grid-column":"left","justify-self":"end"} }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { style: {"grid-column":"left","justify-self":"end"} }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { style: {"grid-column":"left","justify-self":"end"} }
const _hoisted_18 = {
  style: {"grid-column":"right"},
  class: "row gap-04"
}
const _hoisted_19 = { style: {"grid-column":"left","justify-self":"end"} }
const _hoisted_20 = { style: {"grid-column":"right"} }

import { ref, computed, onMounted } from 'vue';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import gen from '@/functions/general.js';
import { LANGUAGE_LIST } from '@/functions/geo.js';
import { GENDER_LIST, GENDER_TERMS, BIOLOGICAL_SEX_LIST, BIOLOGICAL_SEX_TERMS } from '@/functions/office';
import officeapi from '@/api/officeapi';
import relationshipapi from '@/api/relationshipapi';
import EsModal from '@/components/modals/esModal.vue';
import { Popover, Select } from 'primevue';
import { DateFormat } from '@/models/share.model';
import EsInputDateTime from '@/components/esInputDateTime.vue';
import { format } from 'date-fns';
import { apiDateString } from '@/api/apicommon';

type LanguageItem = {
  languageIso: string;
  term: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'personNameInput',
  props: {
  isOpen : {
    type: Boolean,
    required: true
  },
  person: {
    type: Object,
    required: true,
  },
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const currentEntryStore = useCurrentEntryStore()

const props = __props
const emits = __emit
const focusRef = ref();
const languagePopoverRef = ref<InstanceType<typeof Popover> | null>(null);
const currentLanguages = ref<LanguageItem[]>(gen.deepCopy(props.person.languages) || []);
const currentGenderType = ref(props.person?.gender);
const currentBiologicalSexType = ref(props.person?.biologicalSex);
const firstNameInput = ref(props.person?.firstName || "");
const lastNameInput = ref(props.person?.lastName || "");
const nameAtBirthInput = ref(props.person?.nameAtBirth || "");
const birthDate = ref(props.person.birthDate ?? "");

const hasCns = computed(() => Boolean(props.person.cnsHealthInsurance?.cnsAffiliationNumber));

const formattedBirthDate = computed(() => {
  if (!currentEntryStore.modalPatient) return ""
  return apiDateString(currentEntryStore.modalPatient.birthDate)
})

const isCurrPatient = computed(() => {
  return currentEntryStore.modalPatient.personWithRoleId === props.person.personWithRoleId
})

const filteredLanguageList = computed(() => {
  return LANGUAGE_LIST
    .filter(listLanguage => !currentLanguages.value.some(pwrLanguage => pwrLanguage.languageIso === listLanguage.languageIso))
})

function addLanguage(lang: LanguageItem) {
  currentLanguages.value.push(lang);
  languagePopoverRef.value.hide();
}
function removeLanguage(lang: LanguageItem) {
  const isoToRemove = lang.languageIso
  const index  = currentLanguages.value.findIndex(pwrLanguage => pwrLanguage.languageIso === isoToRemove)
  currentLanguages.value.splice(index, 1);
}
async function updatePwrLanguages() {
  const newList: string[] = currentLanguages.value.map(lang => lang.languageIso)
  const oldList: string[] = props.person.languages.map((lang: LanguageItem) => lang.languageIso)
  const added = newList.filter(iso => !oldList.includes(iso))
  const removed = oldList.filter(iso => !newList.includes(iso))
  if (!added.length && !removed.length) return false
  const personWithRoleId = props.person.personWithRoleId
  for (const languageIso of added) {
    await officeapi.addLanguageToPwr(personWithRoleId, languageIso)
  }
  for (const languageIso of removed) {
    await officeapi.removeLanguageFromPwr(personWithRoleId, languageIso)
  }
  return true;
}

async function updatePwrFirstName() {
  if (props.person.firstName === firstNameInput.value) return false;
  const personWithRoleId = props.person.personWithRoleId
  const newText = firstNameInput.value
  await officeapi.updatePwrFirstName(personWithRoleId, newText)
  return true;
}

async function updatePwrLastName() {
  if (props.person.lastName === lastNameInput.value) return false;
  const personWithRoleId = props.person.personWithRoleId
  const newText = lastNameInput.value
  await officeapi.updatePwrLastName(personWithRoleId, newText)
  return true;
}

async function updatePwrNameAtBirth() {
  if (props.person.nameAtBirth === nameAtBirthInput.value) return false;
  const personWithRoleId = props.person.personWithRoleId
  const newText = nameAtBirthInput.value
  await officeapi.updatePwrNameAtBirth(personWithRoleId, newText)
  return true;
}

async function updatePwrBirthDate() {
  if (!hasCns.value && props.person.birthDate === birthDate.value) return false;
  const personWithRoleId = props.person.personWithRoleId
  const newText = format(new Date(birthDate.value), DateFormat.ISO_SMALL);
  await officeapi.updatePwrBirthDate(personWithRoleId, newText)
  return true;
}

async function updatePwrGenderType() {
  if (!isCurrPatient.value) return false;
  if (props.person.gender === currentGenderType.value) return false;
  const personWithRoleId = props.person.personWithRoleId
  const newText = currentGenderType.value
  await officeapi.updatePwrGenderType(personWithRoleId, newText)
  return true;
}


async function updatePwrBiologicalSexType() {
  if (!isCurrPatient.value) return false;
  if (props.person.biologicalSex === currentBiologicalSexType.value) return false;
  const personWithRoleId = props.person.personWithRoleId
  const newText = currentBiologicalSexType.value
  await officeapi.updatePwrBiologicalSexType(personWithRoleId, newText)
  return true;
}

const relationDescriptionInput = ref(props.person.relation?.description || "")
async function updatePatientPersonDescription() {
  if (isCurrPatient.value) return false;
  if (props.person.relation?.description === relationDescriptionInput.value) return false;
  const relationshipId = props.person.relation.relationshipId
  const newText = relationDescriptionInput.value
  await relationshipapi.updatePatientPersonDescription(relationshipId, newText)
  return true;
}

async function deleteRelative() {
  const relationshipId = props.person.relation.relationshipId
  await relationshipapi.deleteRelative(relationshipId)

  emits('close')
  return true;
}

const relationNoteInput = ref(props.person.relation?.note || "")
async function updatePatientPersonNote() {
  if (isCurrPatient.value) return false;
  if (props.person.relation?.note === relationNoteInput.value) return false;
  const relationshipId = props.person.relation.relationshipId
  const newText = relationNoteInput.value
  await relationshipapi.updatePatientPersonNote(relationshipId, newText)
  return true;
}

const toggleLangaugePopover = (event: Event) => {
  languagePopoverRef.value.toggle(event);
}

const noUpdate = ref(false);

const onUpdateBirthDate = (date?: Date | null) => {
  let dateIsoString;
  if (date) {
    dateIsoString = date.toISOString();
  }
  birthDate.value = dateIsoString;
}

const closeFormModal = async () => {
  if (noUpdate.value || !props.person) {
    emits('close');
  }
  let updated = false
  updated = await updatePwrFirstName() || updated
  updated = await updatePwrLastName() || updated
  updated = await updatePwrNameAtBirth() || updated
  updated = await updatePwrBirthDate() || updated
  updated = await updatePwrGenderType() || updated
  updated = await updatePwrBiologicalSexType() || updated
  updated = await updatePwrLanguages() || updated
  updated = await updatePatientPersonDescription() || updated
  updated = await updatePatientPersonNote() || updated
  if (updated) await currentEntryStore.reloadPatientOnly();
  emits('close');
}

onMounted(() => {
  focusRef.value?.innerRef?.focus();
})

return (_ctx: any,_cache: any) => {
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_inputBox = _resolveComponent("inputBox")!
  const _component_deleteItemIcon = _resolveComponent("deleteItemIcon")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_list_group = _resolveComponent("list-group")!
  const _component_inputAreaAuto2 = _resolveComponent("inputAreaAuto2")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_openBlock(), _createBlock(EsModal, {
    title: "Personne",
    isOpen: props.isOpen,
    dismissable: "",
    class: "update-person-modal"
  }, _createSlots({
    footer: _withCtx(() => [
      _createVNode(_component_es_modal_footer, {
        onModalCancel: _cache[8] || (_cache[8] = ($event: any) => (emits('close'))),
        "confirm-modal-method": closeFormModal
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_text_item, { txt: "Nom" })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_inputBox, null, {
            default: _withCtx(() => [
              _createVNode(_component_inputLineNew2, {
                ref_key: "focusRef",
                ref: focusRef,
                modelValue: lastNameInput.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((lastNameInput).value = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        (isCurrPatient.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_text_item, { txt: "Nom de naissance" })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_inputBox, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_inputLineNew2, {
                      modelValue: nameAtBirthInput.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((nameAtBirthInput).value = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_text_item, { txt: "Prénom" })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_inputBox, null, {
            default: _withCtx(() => [
              _createVNode(_component_inputLineNew2, {
                modelValue: firstNameInput.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((firstNameInput).value = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        (!isCurrPatient.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_text_item, { txt: "Lien" })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_inputBox, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_inputLineNew2, {
                      modelValue: relationDescriptionInput.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((relationDescriptionInput).value = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ], 64))
          : _createCommentVNode("", true),
        (isCurrPatient.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_text_item, { txt: "Date de naissance" })
              ]),
              _createElementVNode("div", _hoisted_11, [
                (!hasCns.value)
                  ? (_openBlock(), _createBlock(EsInputDateTime, {
                      key: 0,
                      dateTimeValue: birthDate.value ? new Date(birthDate.value) : null,
                      dateFormat: _unref(DateFormat).DATEPICKER,
                      withTime: false,
                      size: "small",
                      onUpdateDateTime: onUpdateBirthDate,
                      "max-date": new Date()
                    }, null, 8, ["dateTimeValue", "dateFormat", "max-date"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(formattedBirthDate.value), 1))
              ])
            ], 64))
          : _createCommentVNode("", true),
        (isCurrPatient.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_text_item, { txt: "Genre administratif" })
              ]),
              _createVNode(_unref(Select), {
                modelValue: currentGenderType.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((currentGenderType).value = $event)),
                options: _unref(GENDER_LIST),
                size: "small",
                style: {"grid-column":"right"}
              }, {
                value: _withCtx((slotProps) => [
                  (slotProps.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(GENDER_TERMS)[slotProps.value]), 1))
                    : _createCommentVNode("", true)
                ]),
                option: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_unref(GENDER_TERMS)[slotProps.option]), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "options"])
            ], 64))
          : _createCommentVNode("", true),
        (isCurrPatient.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_text_item, { txt: "Sexe biologique" })
              ]),
              _createVNode(_unref(Select), {
                modelValue: currentBiologicalSexType.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((currentBiologicalSexType).value = $event)),
                options: _unref(BIOLOGICAL_SEX_LIST),
                size: "small",
                style: {"grid-column":"right"}
              }, {
                value: _withCtx((slotProps) => [
                  (slotProps.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(BIOLOGICAL_SEX_TERMS)[slotProps.value]), 1))
                    : _createCommentVNode("", true)
                ]),
                option: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_unref(BIOLOGICAL_SEX_TERMS)[slotProps.option]), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "options"])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_text_item, { txt: "Langue(s)" })
        ]),
        _createElementVNode("div", _hoisted_18, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentLanguages.value, (pwrLanguage, index) => {
            return (_openBlock(), _createBlock(_component_button_group, {
              key: index,
              class: "trigger bg-soloitem",
              onClick: ($event: any) => (removeLanguage(pwrLanguage))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_text_item, {
                  txt: pwrLanguage.languageIso
                }, null, 8, ["txt"]),
                _createVNode(_component_deleteItemIcon)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128)),
          (filteredLanguageList.value.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_buttonGroup, { onClick: toggleLangaugePopover }, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_item, { icon: "plus" })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Popover), {
                  ref_key: "languagePopoverRef",
                  ref: languagePopoverRef,
                  class: "language-popover"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredLanguageList.value, (listLanguage, index) => {
                      return (_openBlock(), _createBlock(_component_list_group, {
                        key: index,
                        styles: "pad-s",
                        onClick: ($event: any) => (addLanguage(listLanguage))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: listLanguage.languageIso,
                            styles: "main-h",
                            class: "align-r",
                            style: {"width":"1.25rem"}
                          }, null, 8, ["txt"]),
                          _createVNode(_component_text_item, {
                            txt: listLanguage.term,
                            class: "mleft-08",
                            styles: "main-m"
                          }, null, 8, ["txt"])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }, 512)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        (!isCurrPatient.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_text_item, { txt: "Note" })
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_inputBox, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_inputAreaAuto2, {
                      modelValue: relationNoteInput.value,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((relationNoteInput).value = $event)),
                      lines: 3
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 2
  }, [
    (!isCurrPatient.value)
      ? {
          name: "header",
          fn: _withCtx(() => [
            _createVNode(_component_button_group, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteRelative()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_item, {
                  icon: "trash",
                  styles: "main-m size-m"
                })
              ]),
              _: 1
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["isOpen"]))
}
}

})